export default __webpack_public_path__ + "static/media/wrench-dark.f83af483.svg";